import { getRequest, putRequest } from '../../../../utils'
import { TaxationType } from './enums/taxationType'

export interface FetchTaxationTypeResponseData {
  settings: {
    taxationType: TaxationType
  }
}

export const fetchTaxationType = (organizationId: string): Promise<FetchTaxationTypeResponseData> =>
  getRequest(`/v2/organizations/${organizationId}/settings/taxationType`)

export const updateTaxationType = (
  organizationId: string,
  taxationType: TaxationType,
): Promise<FetchTaxationTypeResponseData> =>
  putRequest(`/v2/organizations/${organizationId}/settings/taxationType`, { value: taxationType })
